import React, { Component } from 'react'
import { Media, Button } from 'reactstrap'

import { getIsIosPwaCapable, getIsIosPwaActive } from '../../utils/functions'

import icon from '../../img/icon.png'
import add from '../../img/add.png'
import share from '../../img/share.png'

class PwaPrompt extends Component{
	_isMounted = false

	constructor(props){
		super(props)

		this.state = {
			isOpen: false
		}
	}

	componentDidMount(){
		this._isMounted = true
		setTimeout(() => this._isMounted && this.setState({isOpen: true}), 20000)
	}

	componentWillUnmount() {
		this._isMounted = false
	}

	closePrompt = () => {
		this.setState({isOpen: false})
	}

	handleKeyDown = (event) => {
		if (event.key === 'Escape' || event.key === 'Enter' || event.key === ' ') {
			event.preventDefault()
			this.closePrompt()
		}
	}

	render(){
		const iconStyle = {
			width: '3rem',
			height: '3rem'
		}
		return (
			<>
				{getIsIosPwaCapable() && !getIsIosPwaActive() && this.state.isOpen && (
					<div 
						className="ios-pwa-prompt fixed-top bg-light rounded p-3 show"
						role="alert"
						aria-live="polite"
						aria-labelledby="pwa-install-title"
						aria-describedby="pwa-install-instructions"
					>
						<Media className="d-flex align-items-center">
							<Media left className="mr-3">
								<Media 
									object 
									src={icon} 
									alt="Icône de l'application PWA" 
									style={iconStyle} 
								/>
							</Media>
							<Media body>
								<Button 
									close 
									onClick={this.closePrompt}
									onKeyDown={this.handleKeyDown}
									aria-label="Fermer la notification d'installation PWA"
									title="Fermer"
								>
									<span aria-hidden="true">×</span>
								</Button>
								<div id="pwa-install-title" className="pwa-install-title">
									<strong>Installez l'application sur iOS</strong>
								</div>
								<div id="pwa-install-instructions" className="pwa-install-instructions">
									Touchez 
									<img 
										src={share} 
										alt="Bouton de partage iOS" 
										aria-hidden="true"
									/> 
									puis 
									<img 
										src={add} 
										alt="Bouton d'ajout à l'écran d'accueil" 
										aria-hidden="true"
									/> 
									<strong>Sur l'écran d'accueil</strong>
								</div>
							</Media>
						</Media>
					</div>
				)}
			</>
		)
	}
}

export default PwaPrompt
